"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeExchangeMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class CodeExchangeMapper {
    toDomain(result) {
        const accessToken = lodash_1.default.get(result, "data.codeExchange.accessToken");
        const expiresIn = lodash_1.default.get(result, "data.codeExchange.expiresIn");
        const refreshToken = lodash_1.default.get(result, "data.codeExchange.refreshToken");
        const idToken = lodash_1.default.get(result, "data.codeExchange.idToken");
        return {
            accessToken,
            expiresIn,
            refreshToken,
            idToken,
        };
    }
}
exports.CodeExchangeMapper = CodeExchangeMapper;
